module.exports = __webpack_public_path__ + "static/media/flag-tn.0da0733c.svg";